<template>
  <div>
    <h2 class="section-title m-4 text-center text-lg">
      {{ $t('tour_my_plan_section_title') }}
    </h2>
    <div id="planList" class="mb-8">
      <div v-if="plans.length > 0">
        <ul class="my-courselist">
          <li v-for="plan in plans" :key="plan.id" class="course">
            <div :class="{ 'expired': plan.expired,'within': !plan.expired }" v-on:click="selectItem(plan.id)">
              <p class="date">{{ plan.date | dateFormat }}</p>
              <p class="name">{{ plan.title }}</p>
              <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
            </div>
          </li>
        </ul>
      </div>
      <div v-else-if="!isUser" class="mt-4 mx-4">
        <p class="text-center" v-html="$t('tour_not_user_my_plan_message')">
        </p>
      </div>
      <div v-else class="mt-4 mx-4">
        <p class="text-center" v-html="$t('tour_not_found_my_plan_message')">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../constants'

export default {
  name: 'MyPlan',
  methods: {
    selectItem (planId) {
      // GoogleAnalytics
      this.$gtag.event("プラン表示", {
        plan_id: planId
      });

      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'plan', params: { lang: this.$store.getters['user/getLang'], id: planId } })
      }else{
        this.$router.push({ name: 'plan', params: { lang: this.$store.getters['user/getLang'], id: planId, areaId: areaId } })
      }
    }
  },
  computed: {
    ...mapGetters({
      plans: 'plans/getAll',
      isUser: 'plans/getIsUser'
    })
  }}
</script>
